// extracted by mini-css-extract-plugin
export default {"container":"about_container__c0wwF","card":"about_card__6o9eY","highlight":"about_highlight__n358M","spreadLine":"about_spreadLine__2RynB"};